export enum MembershipApplication{
    Igs = 'MyAccount',
    Scana = 'ScanaMyAccount',
    ScanaRegulated = 'ScanaRegulatedMyAccount',
}

export const scanaMemberships: ReadonlyArray<string> = [MembershipApplication.Scana, MembershipApplication.ScanaRegulated]